module.exports = __webpack_public_path__ + "static/media/onboarding.29765493.png";